module.exports = __webpack_public_path__ + "static/media/07_Timeline_central.9bf16b23.webp";